export interface LicensePlan {
  billing_period: string;
  code: string;
  feature_flags: Record<string, boolean>;
  id: string;
  max_users: number;
  max_workspaces: number;
  name: string;
}

export interface LicenseSubscription {
  expires_at: string;
  id: string;
  quota_workspaces: number;
  status: string;
}

export interface LicenseTenant {
  id: number;
  name: string;
  slug: string;
  uuid: string;
}

export interface LicenseReady {
  is_blocked: boolean;
  is_read_only: boolean;
  plan: LicensePlan;
  status: string;
  subscription: LicenseSubscription;
  tenant: LicenseTenant;
}

export interface LicenseStatus {
  status: string;
  is_read_only: boolean;
  is_blocked: boolean;
  ready: LicenseReady;
}

export async function fetchLicenseStatus(statusUrl: string): Promise<LicenseStatus> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000);
  try {
    const response = await fetch(statusUrl, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      signal: controller.signal,
      credentials: 'omit',
    });
    if (!response.ok) {
      throw new Error(`License service responded with HTTP ${response.status}`);
    }
    return response.json() as Promise<LicenseStatus>;
  } finally {
    clearTimeout(timeoutId);
  }
}
